import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import { MissingFormatWithOptions } from './internal/MissingFormat.js';
import { TemporalUtils } from './internal/TemporalUtils.js';
// required for `fromNow` to work
dayjs.extend(relativeTime);
export var DayjsRelativeTimeFormat = /*#__PURE__*/ function() {
    "use strict";
    function DayjsRelativeTimeFormat() {
        _class_call_check(this, DayjsRelativeTimeFormat);
    }
    var _proto = DayjsRelativeTimeFormat.prototype;
    _proto.format = function format(value) {
        return TemporalUtils.toDayjs(value).fromNow();
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            locale: dayjs.locale()
        };
    };
    return DayjsRelativeTimeFormat;
}();
export var DayjsRelativeTimeMissingFormat = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(DayjsRelativeTimeMissingFormat, MissingFormatWithOptions);
    function DayjsRelativeTimeMissingFormat(options) {
        _class_call_check(this, DayjsRelativeTimeMissingFormat);
        return _call_super(this, DayjsRelativeTimeMissingFormat, [
            new DayjsRelativeTimeFormat(),
            options
        ]);
    }
    return DayjsRelativeTimeMissingFormat;
}(MissingFormatWithOptions);

//# sourceMappingURL=DayjsRelativeTimeMissingFormat.js.map